import { FC, memo } from 'react'
import { Button } from '@chakra-ui/react'

import ProfessionalContractTypeCard from 'InstitutionalManagement/components/ProfessionalContractTypeCard'
import { ProfessionalContractType } from 'InstitutionalManagement/types'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import { useCustomFormProfessionalContractTypeSelectionDrawerManager } from '../../../../contexts/CustomFormProfessionalContractTypeSelectionDrawerManager/Provider'

type Props = {
  professionalContractType: ProfessionalContractType
  onClose: () => void
}

const CustomFormProfessionalContractTypeCardToSelect: FC<Props> = ({ professionalContractType, onClose }) => {
  const { questionKey, selectedProfessionalContractType, setSelectedProfessionalContractType, filter } =
    useCustomFormProfessionalContractTypeSelectionDrawerManager()

  const { formMethods } = useCustomFormViewer()

  function selectProfessionalContractType(selectedProfessionalContractType: ProfessionalContractType) {
    formMethods?.setValue(questionKey, [
      selectedProfessionalContractType.id,
      selectedProfessionalContractType.slug,
      selectedProfessionalContractType.name,
    ])
    setSelectedProfessionalContractType(selectedProfessionalContractType)
  }

  function removeProfessionalContractType() {
    formMethods?.setValue(questionKey, undefined)
    setSelectedProfessionalContractType({})
  }

  return (
    <ProfessionalContractTypeCard
      professionalContractType={professionalContractType}
      professionalContractTypeFilter={filter}
    >
      {selectedProfessionalContractType?.id === professionalContractType.id ? (
        <Button width="100%" variant="outline" colorScheme="red" onClick={() => removeProfessionalContractType()}>
          Remover
        </Button>
      ) : (
        <Button
          width="100%"
          variant="outline"
          onClick={() => {
            selectProfessionalContractType(professionalContractType)
            onClose()
          }}
        >
          Selecionar
        </Button>
      )}
    </ProfessionalContractTypeCard>
  )
}

export default memo(CustomFormProfessionalContractTypeCardToSelect)
